import type { ReactElement } from 'react';
import { Button } from '@/components/ui/button';

/**
 * KIR-4701: the URL names a security group that cannot be used (deleted, or
 * the groups list failed to load), so the view fell back to the organization. Said out loud, because the page otherwise
 * looks like a plain org visit and the next change would apply org-wide.
 */
export function InventoryScopeUnavailableNotice({
  onSwitchToOrganization,
}: {
  /**
   * Drops the stale `?scope=`. Choosing Organization in the selector cannot:
   * it already shows Organization, and an unchanged Select fires nothing.
   */
  onSwitchToOrganization: () => void;
}): ReactElement {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-900 dark:bg-amber-950 dark:text-amber-100"
    >
      <span>
        The selected security group is not available. Showing the organization
        choices; changes apply to the whole organization.
      </span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={onSwitchToOrganization}
      >
        Switch to organization
      </Button>
    </div>
  );
}
